import { useParams } from "react-router-dom";

// Component to redirect to the new Next JS smart lead page
export function PageSmartLeadRedirect() {
  const { leadShareSlug } = useParams();
  window.location.href = `${process.env.REACT_APP_MOMANG_LEADS_SHARE_FRONTEND_BASE_URL}/shared/${leadShareSlug}`;
  return null;
}
